// extracted by mini-css-extract-plugin
module.exports = {"EventPanel":"EventPanel_EventPanel__1Tcjc"};